// TypingText.js
import React, { useState, useEffect } from "react";

function TypingText({ text, speed = 100, sx }) {
  const [displayedText, setDisplayedText] = useState("");
  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      i++;
      if (i === text.length) clearInterval(interval);
    }, speed);
    return () => clearInterval(interval);
  }, [text, speed]);

  return <span style={sx}>{displayedText}</span>;
}

export default TypingText;
